import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ui/ErrorBoundary';
import ScrollToTop from './components/ui/ScrollToTop';
import LoadingSpinner from './components/ui/LoadingSpinner';
import { usePerformanceMonitor } from './hooks/usePerformanceMonitor';

// Lazy load pages for better performance
const HomePage = React.lazy(() => import('./pages/HomePage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const WebDesignPage = React.lazy(() => import('./pages/WebDesignPage'));
const AIBackendPage = React.lazy(() => import('./pages/AIBackendPage'));
const AIPhoneAssistantPage = React.lazy(() => import('./pages/AIPhoneAssistantPage'));
const CRMLeadCapturePage = React.lazy(() => import('./pages/CRMLeadCapturePage'));
const SchedulingSupportPage = React.lazy(() => import('./pages/SchedulingSupportPage'));
const OutreachAutomationPage = React.lazy(() => import('./pages/OutreachAutomationPage'));
const MissedRevenueCalculatorPage = React.lazy(() => import('./pages/MissedRevenueCalculatorPage'));
const PitchDeckPage = React.lazy(() => import('./pages/PitchDeckPage'));
const PrivacyPolicyPage = React.lazy(() => import('./pages/PrivacyPolicyPage'));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-gray-950 flex items-center justify-center">
    <div className="text-center">
      <LoadingSpinner size="lg" />
      <p className="text-gray-400 mt-4">Loading...</p>
    </div>
  </div>
);

function App() {
  // Monitor performance metrics
  usePerformanceMonitor();

  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/web-design" element={<WebDesignPage />} />
            <Route path="/ai-backend-automation" element={<AIBackendPage />} />
            <Route path="/ai-phone-assistants" element={<AIPhoneAssistantPage />} />
            <Route path="/crm-lead-capture" element={<CRMLeadCapturePage />} />
            <Route path="/scheduling-support" element={<SchedulingSupportPage />} />
            <Route path="/outreach-automation" element={<OutreachAutomationPage />} />
            <Route path="/missed-revenue-calculator" element={<MissedRevenueCalculatorPage />} />
            <Route path="/pitch-deck" element={<PitchDeckPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
}

export default App;